import {useEffect} from "../../__snowpack__/pkg/react.js";
export const useOnMounted = (call) => {
  useEffect(() => {
    call();
  }, []);
};
export const useOnUnmounted = (call) => {
  useEffect(() => {
    return () => {
      call();
    };
  }, []);
};
